/**
 * Создаёт типобезопасный прокси для RPC-функции.
 *
 * - Типы параметров задаются кортежем `TArgs`.
 * - Тип результата задаётся `TReturn` (результат промиса).
 * - Реализация всегда отправляет RPC-запрос на сервер и возвращает `Promise<TReturn>`.
 *
 * Пример использования в генераторе:
 *   makeFunctionProxy<Parameters<typeof serverFn>, Awaited<ReturnType<typeof serverFn>>>(serviceName)
 */
import { fetcher } from '@ayocore/platform/client/helpers/fetcher';
import type { RpcFunctionClient } from './types';

export function makeFunctionProxy<TFn extends (...args: any[]) => any>(
  serviceName: string
): RpcFunctionClient<TFn> {
  return (async (...args: Parameters<TFn>): Promise<Awaited<ReturnType<TFn>>> => {
    const data = { fn: serviceName, args };
    const response = await fetcher.post('/rpc', data);
    return response?.data as unknown as Awaited<ReturnType<TFn>>;
  }) as RpcFunctionClient<TFn>;
}
